import $ from 'jquery';


const dataImage = $('.page-heading--canvas-animation').attr('data-image');
const canv = document.getElementById("canvas");

if(canv) {
const ctx = canv.getContext("2d");
const img = new Image();
const imgMask = new Image();

// imgMask.src = "http://res.cloudinary.com/dkcygpizo/image/upload/v1505176018/codepen/watercolor-effect-2.png";
// imgMask.src = "https://res.cloudinary.com/dkcygpizo/image/upload/v1505176017/codepen/cloud-texture.png";
imgMask.src = "http://emberdev.inspyre.net.nz/wp-content/uploads/cloud.png";
img.src = dataImage;

let speed = 0;
let requestId;

function draw() {
  speed += 30;

  const maskX = (canv.width - (70 + speed)) / 2,
        maskY = (canv.height - (40 + speed)) / 2;

  ctx.clearRect(0, 0, canv.width, canv.height);
  ctx.globalCompositeOperation = "source-over";

  ctx.drawImage(imgMask, maskX, maskY, 70 + speed, 40 + speed);

  ctx.globalCompositeOperation = "source-in";
  ctx.drawImage(img, 0, 0, img.naturalWidth, img.naturalHeight);

  requestId = window.requestAnimationFrame(draw);
}

img.onload = () => {
  canv.width = img.naturalWidth;
  canv.height = img.naturalHeight;

  setTimeout(() => {
    canv.style.display = "block";
    draw();
  }, 200);
}
}